import { AccountModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';

const defaultAccountModelDto: AccountModelDto = {
    id: 0,
    number: '',
    type: '',
    coreStatus: '',
    accountDisplayLabel: '',
    name: '',
    accountUniqueId: '',
};
export class Account extends DomainEntity<AccountModelDto> {
    public createDefault(): this {
        return new Account(defaultAccountModelDto) as this;
    }

    public get number() {
        return this.dto.number;
    }

    public get type() {
        return this.dto.type;
    }

    public get coreStatus() {
        return this.dto.coreStatus;
    }

    public get accountDisplayLabel() {
        return this.dto.accountDisplayLabel;
    }

    public get name() {
        return this.dto.name;
    }

    public get accountUniqueId() {
        return this.dto.accountUniqueId;
    }
}
